import React, { useState } from 'react';
import { CalendarFold, ChevronLeft, ChevronRight, Users } from 'lucide-react';
import { GiTeacher } from 'react-icons/gi';
import { AiFillProduct } from 'react-icons/ai';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from 'images/Anuyog logo.png';
import { useUser } from 'context/UserContext';
import { useLogoutMutation } from 'api/authApi';
import { RiDashboardHorizontalFill } from "react-icons/ri";
import { IoMdHelpCircle } from "react-icons/io";
import { RiSurveyFill } from "react-icons/ri";
import { MdHealthAndSafety } from "react-icons/md";
import Swal from 'sweetalert2';

const Sidebar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { name, email } = useUser();
  const [logout, { isLoading }] = useLogoutMutation();
  const navigate = useNavigate();
  const location = useLocation();

  const superAdminEmails = ['vishaldhabuwala@efsouls.com', 'jprags@gmail.com'];
  const isSuperAdmin = superAdminEmails.includes(email);

  const isActive = (path) => location.pathname.toLowerCase().includes(path.toLowerCase());

  const handleLogout = async () => {
    try {
      await logout().unwrap();
    } catch (error) {
      console.error('Logout failed on backend:', error);
    } finally {
      localStorage.removeItem('token');
      navigate('/login');
    }
  };

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        className="mobile-toggle-btn"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        {mobileOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
      </button>

      {/* Sidebar Container */}
      <div className={`admin-sidebar ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <img src={logo} alt="Logo" className="sidebar-logo" />
            <span className="sidebar-title">Anuyog Admin</span>
          </div>
        </div>

        <div className="sidebar-content">
          <div>
            <div className="sidebar-section-title">Apps & Pages</div>

            <ul className="sidebar-nav">
              <li className="nav-item">
                <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>
                  <RiDashboardHorizontalFill className="nav-icon" />
                  <span className="nav-text">Dashboard</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/workshop" className={`nav-link ${isActive('/workshop') ? 'active' : ''}`}>
                  <CalendarFold className="nav-icon" />
                  <span className="nav-text">Workshop</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/consultancy" className={`nav-link ${isActive('/consultancy') ? 'active' : ''}`}>
                  <GiTeacher className="nav-icon" />
                  <span className="nav-text">Consultant Team</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/product" className={`nav-link ${isActive('/product') ? 'active' : ''}`}>
                  <AiFillProduct className="nav-icon" />
                  <span className="nav-text">Products</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/survey" className={`nav-link ${isActive('/survey') ? 'active' : ''}`}>
                  <RiSurveyFill className="nav-icon" />
                  <span className="nav-text">Surveys</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/healthchecker" className={`nav-link ${isActive('/healthchecker') ? 'active' : ''}`}>
                  <MdHealthAndSafety className="nav-icon" />
                  <span className="nav-text">Health Checker</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/inquiry" className={`nav-link ${isActive('/inquiry') ? 'active' : ''}`}>
                  <IoMdHelpCircle className="nav-icon" />
                  <span className="nav-text">Inquiries</span>
                </Link>
              </li>
              {isSuperAdmin && (
                <li className="nav-item">
                  <Link to="/ManageUser" className={`nav-link ${isActive('/ManageUser') ? 'active' : ''}`}>
                    <Users className="nav-icon" />
                    <span className="nav-text">Users</span>
                  </Link>
                </li>
              )}
            </ul>
          </div>

          <div className="sidebar-footer">
            <button
              onClick={handleLogout}
              disabled={isLoading}
              className="logout-btn"
            >
              <span className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg>
                Logout
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
